import { useConst } from '@wegroup/design-system';
import React, { createContext, useState, useEffect } from 'react';
import i18n from '../../../../../i18n';

interface ITempLanguageContext {
  tempLanguage?: string;
  setTempLanguage?: (arg0: string) => void;
}

export const TempLanguageContext = createContext<ITempLanguageContext | null>(
  null,
);

/**
 * This provider can be used to temporarily set a language. The language will be restored
 * to it's original value when the provider is unmounted. It's best to use this
 * provider together with the useTempLanguage hook.
 */
const TempLanguageProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const language = useConst(i18n.language);
  const [tempLanguage, setTempLanguage] = useState<string>(i18n.language);

  useEffect(() => {
    // Reset the language when the provider is unmounted
    return () => {
      i18n.changeLanguage(language);
    };
  }, []);

  const setTempLanguageFunc = (lang: string) => {
    setTempLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const contextValue = {
    tempLanguage,
    setTempLanguage: setTempLanguageFunc,
  };

  return (
    <TempLanguageContext.Provider value={contextValue}>
      {children}
    </TempLanguageContext.Provider>
  );
};

export default TempLanguageProvider;
